import React from 'react';
import PropTypes from 'prop-types';

// Components
import PaginationLink from './link';

// Styles
import { Wrapper, LinkWrapper } from './styles';

const SubpagePagination = ({ next, previous }) => {
  if (!next && !previous) return null;

  return (
    <nav>
      <Wrapper>
        {previous && (
          <LinkWrapper $linkDirection="prev">
            <PaginationLink
              title="Previous"
              linkDirection="prev"
              label={previous.label}
              path={previous.path}
            />
          </LinkWrapper>
        )}
        {next && (
          <LinkWrapper $linkDirection="next">
            <PaginationLink
              title="Next"
              linkDirection="next"
              label={next.label}
              path={next.path}
            />
          </LinkWrapper>
        )}
      </Wrapper>
    </nav>
  );
};

SubpagePagination.propTypes = {
  next: PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  previous: PropTypes.shape({
    path: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
};

export default SubpagePagination;
